import { render, staticRenderFns } from "./ChatBotExplainErrorButton.vue?vue&type=template&id=3a325a26&scoped=true"
import script from "./ChatBotExplainErrorButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatBotExplainErrorButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChatBotExplainErrorButton.vue?vue&type=style&index=0&id=3a325a26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a325a26",
  null
  
)

export default component.exports